import { z } from 'zod'
import { oc } from '@orpc/contract'
import { authLoginSuccessSchema, nativeClientFields } from './auth-login.contract'

/**
 * /v2/auth/mfa/* (PD-1512) — the gateway's own OTP (the Medplum overlay's 2fa endpoints
 * are not involved). `challengeId` is the opaque state from login/profile-select; codes
 * are hashed, expiring, attempt-capped server-side.
 */

export const authMfaSend = oc
  .route({ method: 'POST', path: '/v2/auth/mfa/send' })
  .input(
    z.object({
      challengeId: z.string().min(1),
      sendTo: z.enum(['phone', 'email']),
      /** Phone enrollment at 2FA time — honored only when the account has no stored phone. */
      phoneNumber: z.string().optional(),
    }),
  )
  .output(
    z.object({
      sentTo: z.enum(['phone', 'email']),
      maskedDestination: z.string(),
    }),
  )

export const authMfaVerify = oc
  .route({ method: 'POST', path: '/v2/auth/mfa/verify' })
  .input(
    z.object({
      challengeId: z.string().min(1),
      code: z.string().min(1),
      rememberDevice: z.boolean().optional(),
      ...nativeClientFields,
    }),
  )
  .output(authLoginSuccessSchema)
